import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppStateService {
  /** Indicates that the app core (auth, billing, niches, etc.) has been fully hydrated. */
  readonly isHydrated = signal(false);

  private hydratedResolve!: () => void;
  private hydratedPromise = new Promise<void>(resolve => {
    this.hydratedResolve = resolve;
  });

  /** Must be called when hydration is complete. */
  setHydrated(): void {
    this.isHydrated.set(true);
    this.hydratedResolve();
  }

  /** Returns a promise that resolves when the app is hydrated. */
  whenHydrated(): Promise<void> {
    return this.hydratedPromise;
  }
}
